import { render, staticRenderFns } from "./StuOpenClass.vue?vue&type=template&id=3a16ef30&scoped=true&"
import script from "./stuopenclass.js?vue&type=script&lang=js&"
export * from "./stuopenclass.js?vue&type=script&lang=js&"
import style0 from "./StuOpenClass.vue?vue&type=style&index=0&id=3a16ef30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a16ef30",
  null
  
)

export default component.exports